import { moveItemInArray } from "@angular/cdk/drag-drop";
import { Component, OnInit, ViewChild, TemplateRef } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { SafeResourceUrl } from "@angular/platform-browser";
import { ActivatedRoute, NavigationStart, Router } from "@angular/router";
import { ModalDismissReasons, NgbModal, NgbModalOptions } from "@ng-bootstrap/ng-bootstrap";

import { AuthService } from "src/app/_app-core/services/auth/auth.service";
import { DateUtilsService } from "src/app/_services/dateUtils";
import { InvoiceService } from "./../../../_services/invoice.service";
import { Config } from "src/app/_store/config";

@Component({
  selector: "app-upload-preview-digital-invoice",
  templateUrl: "./upload-preview-digital-invoice.component.html",
  styleUrls: ["./upload-preview-digital-invoice.component.scss"],
})
export class UploadPreviewDigitalInvoiceComponent implements OnInit {
  @ViewChild('sizeErrorModal') sizeErrorModal: TemplateRef<any>;
  Config = Config;
  invoiceDetails: any;
  invoiceType: any;
  closeResult: string = "";
  modalOptions: NgbModalOptions;
  loading: boolean = false;
  invoiceSaved: boolean = false;
  uploadInvoice: boolean = false;
  uploadSuccessful: boolean = false;
  saving: boolean = false;
  displayName: any;
  hasError = false;
  safeUrl: SafeResourceUrl = "";
  pdfSrc: any;
  fileLink: any;
  fileSizeError = false;
  fileTypeError = false;
  dateError = false;
  typeError = false;
  sizeError = false;
  supportingDocuments: any[] = [];
  agreed = [{ status: false }];
  invoiceFile: any;
  invoiceDataToSave: any;
  isInvoiceChange: boolean = false;
  isUpdatedData: boolean = false;
  invoiceChanged: boolean = false;
  responseData: any;
  isCondensed: boolean = false;
  currentLayout = {
    isCondensed: true,
  };
  barcodeNo: any;
  poNo: any;
  eInvoice = false;
  formData: any;
  irnExist: boolean = false;
  dsLoaderMsg = "";
  formSubmitted = false;
  previousUrl: any;
  totalSizeError = false;
  files: File[];
  supportingDocsAdded = false;
  invalidDate = false;
  canSubmitForm = false;
  allDeleted = false;

  digitalInvoice = new FormGroup({
    SellerGstin: new FormControl("", [Validators.required, Validators.minLength(15), Validators.maxLength(15)]),
    file_link: new FormControl(""),
    BuyerGstin: new FormControl(""),
    DocNo: new FormControl("", [Validators.required]),
    DocTyp: new FormControl(""),
    DocDt: new FormControl("", [Validators.required]),
    TotInvVal: new FormControl(null, [
      Validators.required,
      Validators.pattern("^([0-9]+(.?[0-9]?[0-9]?)?)"),
    ]),
    ItemCnt: new FormControl(""),
    Irn: new FormControl("", [Validators.minLength(64), Validators.maxLength(64)]),
    IrnDt: new FormControl(""),
    MainHsnCode: new FormControl(""),
    file: new FormControl(""),
    supportingFiles: new FormControl([]),
    fileSource: new FormControl(""),
    documentSource: new FormControl(""),
    terms_agreed: new FormControl(false),
  });

  constructor(
    private modalService: NgbModal,
    private router: Router,
    private route: ActivatedRoute,
    private invoiceService: InvoiceService,
    private authService: AuthService,
    private dateUtils: DateUtilsService
  ) {
    this.modalOptions = {
      backdrop: "static",
      backdropClass: "customBackdrop",
      scrollable: true,
    };

    this.router.events.subscribe((val) => {
      if (val instanceof NavigationStart) {
        this.previousUrl = val.url;
      }
    });
  }

  toggleSidebar() {
    this.currentLayout.isCondensed = !this.currentLayout.isCondensed;
    document.body.setAttribute("data-sidebar-size", this.currentLayout.isCondensed ? "condensed" : "default");
  }

  canDeactivate() {
    if (!this.formSubmitted) {
      this.loading = true;
      return false;
    } else {
      return true;
    }
  }

  setAsDirty() {
    this.digitalInvoice.controls["Irn"].markAsDirty;
  }

  exitForm() {
    this.loading = false;
    this.formSubmitted = true;
    this.router.navigateByUrl(this.previousUrl);
  }

  cancelExit() {
    this.loading = false;
  }

  selectDocuments(event: any) {
    const ALLOWED_TYPES = ["application/pdf"];

    this.files = Array.from(event);
    const totalSize = this.files.reduce((sum, file) => sum + file.size, 0);

    if (totalSize > Config.maxTotalSupportingDocsSize) {
      this.totalSizeError = true;
      this.sizeError = false;
      this.typeError = false;
      this.modalService.open(this.sizeErrorModal, this.modalOptions);
    }

    for (const file of this.files) {
      if (file.size > Config.maxFileSize) {
        this.sizeError = true;
        this.typeError = false;
        this.totalSizeError = false;
        continue;
      }

      // Filter out any files that are not Word, Excel, or PDF
      if (!ALLOWED_TYPES.includes(file.type)) {
        this.typeError = true;
        this.sizeError = false;
        this.totalSizeError = false;
        continue;
      }
      this.supportingDocuments.push(file);
    }

    if (this.allDeleted === true) {
      if (this.digitalInvoice.get("terms_agreed").value === true) {
        this.digitalInvoice.patchValue({ terms_agreed: false });
      }
    } else {
      this.digitalInvoice.patchValue({ terms_agreed: false });
    }

    this.supportingDocsAdded = true;
  }

  /**
   * Delete file from files list
   * @param index (File index)
   */
  deleteFile(index: number) {
    this.supportingDocuments.splice(index, 1);
    this.recomputeFileErrors();

    if (this.supportingDocuments.length === 0) {
      if (this.digitalInvoice.get("terms_agreed").value === true) {
        this.digitalInvoice.patchValue({ terms_agreed: false });
      }

      this.canSubmitForm = false;
      this.allDeleted = true;
      this.supportingDocsAdded = false;
    }
  }

  checkSupportingDocuments() {
    if (this.supportingDocuments.length > 0 && this.digitalInvoice.get("terms_agreed").value === false && !this.invalidDate) {
      this.canSubmitForm = true;
    } else {
      this.canSubmitForm = false;
    }
  }

  private recomputeFileErrors() {
    const totalSize = this.supportingDocuments.reduce((sum, f) => sum + (f.size || 0), 0);
    if (totalSize <= Config.maxTotalSupportingDocsSize) this.totalSizeError = false;
    this.sizeError = false;
    this.typeError = false;
  }

  onDrop(event: any) {
    // Update the list order
    moveItemInArray(this.supportingDocuments, event.previousIndex, event.currentIndex);
    this.supportingDocsAdded = true;

  }

  open(content: any) {
    this.modalService.open(content, this.modalOptions).result.then(
      (result) => {
        this.closeResult = `Closed with: ${result}`;
      },
      (reason) => {
        this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
      }
    );
  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return "by pressing ESC";
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return "by clicking on a backdrop";
    } else {
      return `with: ${reason}`;
    }
  }

  reUploadInvoice(event: any) {
    if (event.length > 0) {
      const fileUploaded = event[0];


      if (fileUploaded.type !== "application/pdf") {
        this.hasError = false;
        this.fileSizeError = false;
        this.fileTypeError = true;
      } else if (fileUploaded.size > Config.maxFileSize) {
        this.fileTypeError = false;
        this.hasError = false;
        this.fileSizeError = true;
        this.modalService.open(this.sizeErrorModal, this.modalOptions);
      } else {
        this.fileSizeError = false;
        this.fileTypeError = false;

        if (typeof FileReader !== "undefined") {
          let reader = new FileReader();
          reader.onload = (e: any) => {
            this.pdfSrc = e.target.result;
          };
          let $file: any = fileUploaded;
          reader.readAsArrayBuffer($file);
        }

        this.digitalInvoice.patchValue({
          fileSource: fileUploaded,
        });

        this.hasError = false;
        this.isInvoiceChange = true;
        this.loading = true;
        this.formSubmitted = true;
        this.invoiceChanged = true;

        // Create ledger array similar to digital signature verification
        const ledger: any[] = [
          {
            docType: "APINV",
            docDetail: {
              docFormat: "ds-invoice",
              docCat: "po_based",
            },
            cmpCode: this.invoiceDetails?.cmpCode || "",
            purchaseOrg: this.invoiceDetails?.purchaseOrg || "",
            erpDocType: this.invoiceDetails?.erpDocType || "",
          },
        ];

        const formData: any = new FormData();
        formData.append("sellerCode", localStorage.getItem("sellerCode"));
        formData.append("ledger", JSON.stringify(ledger));
        formData.append("invoiceFile", this.digitalInvoice.value.fileSource);
        formData.append("supplierCode", localStorage.getItem("vendorCode"));
        formData.append("docNo", this.invoiceDetails?.poNo || "");

        this.dsLoaderMsg = "Verifying Signature";

        setTimeout(() => {
          this.dsLoaderMsg = "Authenticating Signature";
        }, 5000);
        setTimeout(() => {
          this.dsLoaderMsg = "Extracting Data";
        }, 10000);
        setTimeout(() => {
          this.dsLoaderMsg = "Validating Data";
        }, 15000);

        this.invoiceService.verifyDigitalSignature(formData).subscribe(
          (res) => {
            this.loading = false;
            this.invoiceChanged = false;
            this.formSubmitted = false;
            this.responseData = res;

            if (this.responseData.length !== 0 && this.responseData.status === "error") {
              this.hasError = true;
            } else {
              this.formData = this.responseData.data;
              if (typeof this.formData.irn !== "undefined") {
                this.irnExist = true;
              } else {
                this.irnExist = false;
              }

              let dDate;
              if (typeof this.formData.invoiceDate !== "undefined") {
                // Validate the invoiceDate format and year length
                const docDtFormControl = this.digitalInvoice.controls["DocDt"] as FormControl;
                docDtFormControl.valueChanges.subscribe((newDate) => {
                  this.checkAndUpdateDateValidity(newDate);
                });
                dDate = this.formData.invoiceDate.replaceAll(".", "/");
              } else {
                dDate = "";
              }

              this.digitalInvoice.patchValue({
                SellerGstin: this.formData.vendorGSTIN,
                DocNo: this.formData.invoiceNumber,
                DocDt: this.formData.invoiceDate.replaceAll(".", "/"),
                TotInvVal: this.formData.invoiceAmount,
                Irn: this.formData.irn,
              });
              this.fileLink = this.responseData.file_link;
              this.hasError = false;
            }
          },
          (error) => {
            console.error(error);
          }
        );
      }
    }
  }

  onSubmitDigitalInvoice() {
    this.loading = true;
    this.uploadInvoice = true;
    this.formSubmitted = true;

    this.poNo = localStorage.getItem("poNo");
    const lineItems = localStorage.getItem("pods");


    const convertPods = JSON.parse(lineItems);
    const poItems: any = [];

    convertPods.forEach((p: any) => {
      if (p.docNo !== "" || typeof p.docNo !== "undefined") {
        poItems.push({
          poNo: p.poNo,
          itemNo: p.poLineNo,
          grn: p._id,
        });
      } else {
        poItems.push({
          poNo: p.poNo,
          itemNo: p.poLineNo,
          grn: "",
        });
      }
    });

    let companyCode = "";
    let purchaseOrg = "";
    let docType = "";

    if (convertPods[0].docNo !== "") {
      companyCode = convertPods[0].cmpCode;
      purchaseOrg = convertPods[0].purchaseOrg;
      docType = convertPods[0].erpDocType;
    } else {
      companyCode = localStorage.getItem("servCompanyCode");
      purchaseOrg = localStorage.getItem("servPurchaseOrg");
      docType = localStorage.getItem("servDocType");
    }

    const userData = {
      req: {
        companyCode: companyCode,
        purchaseOrg: purchaseOrg,
        docType: docType,
        items: poItems,
      },
    };

    if (this.isInvoiceChange === true) {
      this.invoiceFile = this.digitalInvoice.value.fileSource;
    } else {
      this.invoiceFile = this.invoiceService.getFileElement();
    }

    const fileOrder = [];
    this.supportingDocuments.forEach((file, index) => {
      const obj = {};
      obj[(index + 1).toString()] = file.name;
      fileOrder.push(obj);
    });

    const currentUser = this.authService.getCurrentUser();
    const session = currentUser.eippSessionData.data.session;

    const led = this.invoiceService.getDataDigitalInvoice();
    const timestamp = Date.now();

    const ledger = [
      {
        docDate: this.dateUtils.formatDateString(this.digitalInvoice.get("DocDt").value),
        dueDate: this.dateUtils.formatDateString(this.digitalInvoice.get("DocDt").value),
        dueAmt: parseFloat(this.digitalInvoice.value.TotInvVal),
        docAmt: parseFloat(this.digitalInvoice.value.TotInvVal),
        docType: "APINV",
        poNo: convertPods[0].poNo,
        docNo: this.digitalInvoice.get("DocNo").value,
        timestamp: timestamp,
        currCode: "INR",
        status: "PENDING_SUBMISSION",
        barcodePrefix: this.invoiceDetails.barcodePrefix,
        supplierNm: localStorage.getItem("displayName"),
        docDetail: {
          docAmt: this.digitalInvoice.value.TotInvVal,
          docFormat: "ds-invoice",
          docCat: "po_based",
          docGstin: this.digitalInvoice.get("SellerGstin").value,
          irn: this.digitalInvoice.get("Irn").value,
        },
        docRef: [
          {
            src: this.invoiceDetails.file_link,
          },
        ],
        lineItemDetail: convertPods.map((pod: any) => ({
          poLineNo: pod.poLineNo,
          grn: pod._id,
          grnNo: pod.docNo,
        })),
        supplierCode: convertPods[0].supplierCode[0],
        cmpCode: convertPods[0].cmpCode,
        purchaseOrg: convertPods[0].purchaseOrg,
        erpDocType: convertPods[0].erpDocType,
      },
    ];

    const formData: any = new FormData();
    formData.append("sellerCode", this.authService.getSellerCode());
    formData.append("reqType", "payexap");
    formData.append("session", JSON.stringify(session));
    formData.append("action", "add");
    formData.append("ledger", JSON.stringify(ledger));

    if (this.supportingDocuments.length !== 0) {
      for (let i = 0; i < this.supportingDocuments.length; i++) {
        formData.append("supportingDocs", this.supportingDocuments[i]);
      }
    } else {
      formData.append("supportingDocs", this.supportingDocuments);
    }

    // for (const value of formData.values()) {
    // }

    this.invoiceService.uploadInvoiceWithoutExtration(formData).subscribe(
      (res) => {
        this.responseData = res;
        if (this.responseData.status === "error") {
          this.loading = false;
          this.uploadInvoice = false;
          this.hasError = true;
          this.formSubmitted = false;
        } else {
          this.barcodeNo = this.responseData.barcode;
          this.uploadSuccessful = true;
          this.uploadInvoice = false;
        }
      },
      (error) => {
        this.loading = false;
        // this.error = error.error.message;
        this.uploadInvoice = false;
        this.uploadSuccessful = false;
        this.invoiceSaved = false;
        // this.serverError = true;
      }
    );

  }

  ngOnInit(): void {
    this.displayName = localStorage.getItem("displayName");
    this.invoiceDetails = this.invoiceService.getDataDigitalInvoice();
    this.loadFile();
    this.formSubmitted = false;

    this.fileLink = this.invoiceService.fileUrl;

    this.formData = this.invoiceService.getDataDigitalInvoice();

    if (typeof this.formData.irn !== "undefined") {
      this.irnExist = true;
    }

    let documentDate;
    if (typeof this.formData.invoiceDate !== "undefined") {
      // Validate the invoiceDate format and year length
      const docDtFormControl = this.digitalInvoice.controls["DocDt"] as FormControl;
      docDtFormControl.valueChanges.subscribe((newDate) => {
        this.checkAndUpdateDateValidity(newDate);
      });
      documentDate = this.formData.invoiceDate.replaceAll(".", "/");
    } else {
      documentDate = "";
    }

    this.digitalInvoice.patchValue({
      SellerGstin: this.formData.gstin,
      DocNo: this.formData.invoice_number,
      DocDt: this.formData.invoice_date,
      TotInvVal: this.formData.invoice_amount,
      Irn: this.formData.irn,
    });

    this.setAsDirty();
  }

  ngAfterViewInit(): void {
    // Subscribe to changes of the DocDt FormControl after initialization
    const docDtFormControl = this.digitalInvoice.get("DocDt") as FormControl;

    docDtFormControl.valueChanges.subscribe((newDate) => {
      this.checkAndUpdateDateValidity(newDate);
    });
  }

  checkAndUpdateDateValidity(newDate) {
    if (!this.isDateValid(newDate)) {
      this.invalidDate = true;
      this.dateError = true;
    } else {
      if (this.digitalInvoice.get("terms_agreed").value === true) {
        this.digitalInvoice.patchValue({ terms_agreed: false });
      }
      this.invalidDate = false;
      this.dateError = false;
    }
  }

  isDateValid(dateString: string): boolean {
    const dateParts = dateString.split(/[./]/); // Split using either "." or "/"

    if (dateParts.length !== 3) {
      return false;
    }

    const day = Number(dateParts[0]);
    const month = Number(dateParts[1]);
    const year = Number(dateParts[2]);

    const currentYear = new Date().getFullYear();

    // Check if day is within the range of 1 to 31 and not NaN
    if (isNaN(day) || day < 1 || day > 31) {
      return false;
    }

    // Check if month is within the range of 1 to 12 and not NaN
    if (isNaN(month) || month < 1 || month > 12) {
      return false;
    }

    // Check if year is within the range of 2000 to current year and not NaN
    if (isNaN(year) || year < 2000 || year > currentYear) {
      return false;
    }

    return true;
  }

  closeSuccessDialog() {
    this.loading = false;
    this.router.navigateByUrl("/invoices");
  }

  resubmitInvoice() {
    const poNo = this.route.snapshot.params["poNo"];
    this.router.navigate(["/submit-invoice", poNo]);
  }

  loadFile() {
    if (typeof FileReader !== "undefined") {
      let reader = new FileReader();
      reader.onload = (e: any) => {
        this.pdfSrc = e.target.result;
      };
      let $file: any = this.invoiceService.getFileElement();
      reader.readAsArrayBuffer($file);
    }
  }

  onCheckboxChange(e: any) {
    if (e.target.checked) {
      this.digitalInvoice.patchValue({
        terms_agreed: e.target.value,
      });
    } else {
      this.digitalInvoice.patchValue({
        terms_agreed: null,
      });
    }
  }
}
